import {
  arrayUnion,
  collectionGroup,
  doc,
  getDocs,
  query,
  updateDoc,
  where,
} from 'firebase/firestore';

import { BADGE_BILGE_ANNEDAS, BADGE_GUVENILIR_SATICI } from '../constants/badges';
import { getFirestoreDb } from '../config/firebaseApp';
import { getMarketplaceListingsBySeller } from './communityService';

/**
 * Kullanıcının tüm forum yorumlarındaki toplam beğeni ≥ eşik ise `bilge_annedas` rozetini ekler.
 * Yalnızca kendi `users/{uid}` belgesine yazılır (kurallarla uyumlu).
 */
export async function syncBilgeAnnedasBadge(uid: string, minLikes = 3): Promise<void> {
  const db = getFirestoreDb();
  const q = query(collectionGroup(db, 'comments'), where('authorId', '==', uid));
  const snap = await getDocs(q);
  let total = 0;
  snap.forEach(d => {
    const lb = d.data().likedBy;
    if (Array.isArray(lb)) {
      total += lb.length;
    }
  });
  if (total < minLikes) {
    return;
  }
  await updateDoc(doc(db, 'users', uid), {
    badges: arrayUnion(BADGE_BILGE_ANNEDAS),
  });
}

/** Satıcının toplam ilan sayısı > eşik ise `guvenilir_satici` rozetini ekler. */
export async function maybeAwardTrustedSellerBadge(
  sellerId: string,
  minListings = 5,
): Promise<void> {
  const list = await getMarketplaceListingsBySeller(sellerId);
  if (list.length <= minListings) {
    return;
  }
  await updateDoc(doc(getFirestoreDb(), 'users', sellerId), {
    badges: arrayUnion(BADGE_GUVENILIR_SATICI),
  });
}
